export default "__VITE_ASSET__DvVS1Zzd__";